import { j as l } from "../../../jsx-runtime-p91LotPX.mjs";
import { cloneElement as p } from "react";
import { GrowTypography as i } from "../../Typography/AntTypography.js";
import { BulkActionWrapper as m } from "./style.js";
function g(o) {
  const {
    components: t,
    api: n,
    selectedRows: e,
    table: r
  } = o, s = r.selectAll.select_all, c = t ? p(t, {
    api: n,
    selectedRows: e
  }) : null;
  return e.length ? /* @__PURE__ */ l.jsxs(m, { align: "center", wrap: !0, space: "12", children: [
    /* @__PURE__ */ l.jsx(i.Text, { strong: !0, style: {
      color: "var(--primary-7)"
    }, children: `${s ? r.bulk_records : e.length} Selected ` }),
    c
  ] }) : null;
}
export {
  g as default
};
//# sourceMappingURL=BulkActions.js.map
